export default {
	methods: {
		appUiLocationChange($event,app,list) {
			let vm = this

			//UI location needs to be updated
			let payload = {
				ui_location: $event 
			}

			if ("AddonAppInstalled" in app)
				payload.id = app.AddonAppInstalled[0].id
			else if ("AddonApp" in app)
				payload.id = app.id

			this.postData("AddonAppInstalled/save",payload,true).then(response => {
				if (response.success) {
					vm.fetchCompanyData(false,["CompanySetting","AddonApp"])
					vm.alertSuccess("Install location changed")
				}
			})
			
		},
		appInTopMenuChange($event, app) {
			let vm = this

			let payload = {
				in_top_menu: $event
			}

			if ("AddonAppInstalled" in app)
				payload.id = app.AddonAppInstalled[0].id
			else if ("AddonApp" in app)
				payload.id = app.id

			this.postData("AddonAppInstalled/save", payload, true).then(response => {
				if (response.success) {
					if (app.AddonAppInstalled && app.AddonAppInstalled[0])
						app.AddonAppInstalled[0].in_top_menu = $event

					vm.fetchCompanyData(false, ["CompanySetting", "AddonApp"])
					vm.alertSuccess("Top Bar setting saved")
				}
			})
		},
		appInSideMenuChange($event, app) {
			let vm = this

			let payload = {
				in_side_menu: $event
			}

			if ("AddonAppInstalled" in app)
				payload.id = app.AddonAppInstalled[0].id
			else if ("AddonApp" in app)
				payload.id = app.id

			this.postData("AddonAppInstalled/save", payload, true).then(response => {
				if (response.success) {
					if (app.AddonAppInstalled && app.AddonAppInstalled[0])
						app.AddonAppInstalled[0].in_side_menu = $event

					vm.fetchCompanyData(false, ["CompanySetting", "AddonApp"])
					vm.alertSuccess("Side Menu setting saved")
				}
			})
		},
		appTokenIsReadonlyChange($event, app) {
			let vm = this

			let payload = {
				token_is_readonly: $event
			}

			if ("AddonAppInstalled" in app)
				payload.id = app.AddonAppInstalled[0].id
			else if ("AddonApp" in app)
				payload.id = app.id

			this.postData("AddonAppInstalled/save", payload, true).then(response => {
				if (response.success) {
					if (app.AddonAppInstalled && app.AddonAppInstalled[0])
						app.AddonAppInstalled[0].token_is_readonly = $event

					app.token_is_readonly = $event

					vm.fetchCompanyData(false, ["CompanySetting", "AddonApp"])
					vm.alertSuccess("API permission setting saved")
				}
			})
		},
		addonAppTokenIsReadonly(app) {
			if (app.AddonAppInstalled && app.AddonAppInstalled[0] && app.AddonAppInstalled[0].token_is_readonly == 1)
				return true

			if (app.token_is_readonly == 1)
				return true

			return false
		},
		buildAddonAppIframeSrc(app, token) {
			let url = app.src

			if (url.indexOf("?") >= 0)
				return url+"&token="+token
			else
				return url+"?token="+token
		},
		resolveAddonAppIframeSrc(app) {
			let vm = this

			return new Promise(resolve => {
				if (!app || !app.src) {
					resolve("")
					return
				}

				if (!vm.addonAppTokenIsReadonly(app)) {
					resolve(vm.buildAddonAppIframeSrc(app, vm.$store.sessionToken))
					return
				}

				vm.postData("UserToken/create", {
					is_readonly: 1,
					expiry_hrs: 12,
					label: "Addon App: "+(app.app_name || "")
				}, true).then(response => {
					if (response.success)
						resolve(vm.buildAddonAppIframeSrc(app, response.data.token))
					else
						resolve("")
				})
			})
		},
		uninstallApp(appIndex) {
			let vm = this

			let sync = this.primitize(this.installedApps)

			//remove from array of istalled apps
			sync.splice(appIndex,1)

			let payload = {
				id: this.$store.company.id,
				AddonApp: sync
			}

			return new Promise((resolve,reject) => {

				vm.postData("Company/save",payload,true).then(response => {
					if (response.success) {
						vm.alertSuccess("App un-installed")

						vm.fetchCompanyData(false,["CompanySetting","AddonApp"])

						resolve(response)
					}
				})

			})
		},
		fetchInstalledApps() {
			let vm = this

			this.spinner(true)

			let params = {
				include: [
					"AddonAppInstalled",
					{model: "User",fields: ["id","slug","first_name","last_name"]}
				],
				filters: [
					["AddonAppInstalled.tenant_id",this.$store.company.id]
				]
			}

			this.getJSON("AddonApp/get",params,true).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.installedApps = response.data.map(app => {
						app.showInstallLocation = true

						return app
					})
				}
			})
		}
	}
}